(function(){
    'use strict';

    angular.module('elogbooks.common.form-associations', []);
})();
